import React from "react";
import {
  Users,
  DollarSign,
  Clock,
  TrendingUp,
  GraduationCap,
  Award,
} from "lucide-react";

const iconMap = {
  users: Users,
  "dollar-sign": DollarSign,
  clock: Clock,
  "trending-up": TrendingUp,
  "graduation-cap": GraduationCap,
  award: Award,
};

export default function ReportDataSummary({ card }) {
  if (!card) return <p className="text-sm text-gray-500">No report found</p>;

  const Icon = iconMap[card.icon];

  return (
    <div
      className={`p-4 flex flex-col gap-2 rounded-b-none report card-select 
                  cursor-pointer transition-all duration-300 
                  ${`bg-gradient-to-br ${card.title.toLowerCase().replace(/\s+/g, "-")}`}`}
    >
      <div className="flex items-start gap-3">
        <div
          className={`p-2.5 shadow-md !rounded-2xl icon-style ${card.title
            .toLowerCase()
            .replace(/\s+/g, "-")}`}
        >
          {Icon && <Icon className="w-5 h-5 text-white" />}
        </div>

        <div className="flex-1 space-y-1">
          <h4 className="text-base">{card.title}</h4>
          <span className="status-indicator normal text-[9px] py-0">
            {card.timestamp || card.generatedAt}
          </span>
          <span className="status-indicator normal text-[9px] py-0">
            {card.dateRange}
          </span>
          <span className="status-indicator normal text-[9px] py-0">
            {card.departments?.length || 0}{" "}
            {card.departments?.length === 1 ? "department" : "departments"}
          </span>
        </div>
      </div>
    </div>
  );
}
